import { initializeFaro as coreInit, getWebInstrumentations } from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { GRAFANA_URL, GRAFANA_APIKEY } from '../../constants/settings';

export function initializeGrafana() {
  try {
    const faro = coreInit({
      url: GRAFANA_URL,
      apiKey: GRAFANA_APIKEY,
      app: {
        name: 'CMS',
        version: '1.0.0',
      },
      instrumentations: [
        ...getWebInstrumentations({
          captureConsole: true,
        }),
        new TracingInstrumentation(),
      ],

      session: window.__PRELOADED_STATE__?.faro?.session,
      batching: {
        enabled: true,
        sendTimeout: 1000, // ms
        maxSize: 10, // кол-во событий
      },
    });
    faro.api.pushLog(['Frontend initialize success']);

    return faro;
  } catch (error) {
    console.error('Grafana Faro initialization failed:', error);
  }
}
